/**
 * Marca del vehículo: prioriza model.brand.name (FK) y cae al campo legacy brand.
 */
export function getVehicleBrand(vehicle) {
  return vehicle?.model?.brand?.name || vehicle?.brand || null;
}

export function formatVehicleBrandModel(vehicle, separator = ' ') {
  const brand = getVehicleBrand(vehicle);
  const model =
    vehicle?.model?.description || vehicle?.model || null;
  return [brand, model].filter(Boolean).join(separator) || '—';
}
